var map = {
	"./music/main_menu.mp3": 1198,
	"./music/walka.mp3": 1199,
	"./music/wyscig.mp3": 1200,
	"./sounds/chlopi.mp3": 1201,
	"./sounds/demon_attack.mp3": 1202,
	"./sounds/hit1.mp3": 1203,
	"./sounds/hit2.mp3": 1204,
	"./sounds/hit3.mp3": 1205,
	"./sounds/latajacy obiekt.mp3": 1206,
	"./sounds/melee_specj_um.mp3": 1207,
	"./sounds/rabbit_attack.mp3": 1208,
	"./sounds/reka_attack.mp3": 1209,
	"./sounds/shooter_attack.mp3": 1210,
	"./sounds/whip01-6952.mp3": 1211,
	"./sounds/woz.mp3": 1212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1230;